module.exports = __webpack_public_path__ + "img/result_txt_gb.272888dc.png";